import ApiEndpointConstants from "../constants/ApiEndpointConstants";
import api from "./API";
import LocalStorageUtil from "../utils/LocalStorageUtil";

export const postMessage = (text, groupid) => {
  const formatText = `${text} : ad=${LocalStorageUtil.loadAdParams()},user=${LocalStorageUtil.loadAnonymousUserId()}`;
  return api.post(`${ApiEndpointConstants.POST_MESSAGE}`, {
    text: formatText,
    groupid,
  });
};
